<ngx-loading [show]="loading" [config]="{ fullScreenBackdrop : true }"></ngx-loading>

<!--
<img class="nestbanner" src = "assets/images/carnival.jpg">




<div class="container-login"  >
    <div class="wrap-login">
      <div class="row">


            <div class="form-group"  >

                <form [formGroup]="registrationform"  (ngSubmit)=" doSignup()">
                    <div class="wrap-inputlogin form-group">

                    <input type="text" name="name" placeholder="Enter your Name" id="name" [(ngModel)]="registrationform.name" class="inputlogin form-control" formControlName="name" >
                    <span class="symbol-inputlogin">
                      <i class="fa fa-user" aria-hidden="true"></i>
                    </span>
                    </div>
                    <div  *ngIf="( registrationform.get('name').hasError('required') ) && registrationform.get('name').touched">

                            <div class="error" style="color:red;font-size:10px" *ngIf="registrationform.get('name').hasError('required') && registrationform.get('name').touched">
                            Name is required
                          </div>
                    </div>

                    <div class="wrap-inputlogin form-group">

                    <input type="email" placeholder="Enter email Id" name="email" id="email" [(ngModel)]="registrationform.email" class="inputlogin form-control" formControlName="email" required>
                    <span class="symbol-inputlogin">
                      <i class="fa fa-envelope" aria-hidden="true"></i>
                    </span>
                    </div>

                    <div *ngIf="( registrationform.get('email').hasError('required') || registrationform.get('email').hasError('pattern') ) && registrationform.get('email').touched">

                                <div class="error" style="color:red;font-size:10px" *ngIf="registrationform.get('email').hasError('required') && registrationform.get('email').touched">
                                          Email is required
                                </div>
                                <div class="error" style="color:red;font-size:10px" *ngIf="registrationform.get('email').hasError('pattern') && registrationform.get('email').touched">
                                            Enter Correct Email Id
                                </div>
                    </div>



                    <div class="wrap-inputlogin form-group">

                    <input type="mobile" placeholder="Enter Mobile No" name="mobile" id="mobile" [(ngModel)]="registrationform.mobile" class="inputlogin form-control" formControlName="mobile" required>
                    <span class="symbol-inputlogin">
                      <i class="fa fa-phone" aria-hidden="true"></i>
                    </span>
                    </div>

                    <div  *ngIf="( registrationform.get('mobile').hasError('required')  || registrationform.get('mobile').hasError('minLength') ) && registrationform.get('mobile').touched">

                      <div class="error" style="color:red;font-size:10px" *ngIf="registrationform.get('mobile').hasError('required') && registrationform.get('mobile').touched">
                        Mobile Number is required
                      </div>
                      <div class="error" style="color:red;font-size:10px" *ngIf="registrationform.get('mobile').hasError('minLength') && registrationform.get('mobile').touched">
                        This is not a valid Mobile Number
                      </div>

                    </div>


                    <div class="wrap-inputlogin form-group">
                    <input type="noofpets" placeholder="No of Pets" name="noofpets" id="noofpets"  [(ngModel)]="registrationform.noofpets" class="inputlogin form-control" formControlName="noofpets" required>
                    <span class="symbol-inputlogin">
                      <i class="fas fa-paw" aria-hidden="true"></i>
                    </span>

                    </div>

                    <div *ngIf="( registrationform.get('noofpets').hasError('required') ) && registrationform.get('noofpets').touched">

                                          <div class="error" style="color:red;font-size:10px" *ngIf="registrationform.get('noofpets').hasError('required') && registrationform.get('noofpets').touched">
                                          No of Pets is required
                                          </div>

                                        </div>




                    <div class="wrap-inputlogin form-group smlfnt" >


                                <md-radio-group [(ngModel)]="typeofpets" formControlName="typeofpets">Pet Type:
                                <md-radio-button value="dog">Dog</md-radio-button>
                                <md-radio-button value="cat">Cat</md-radio-button>
                                <md-radio-button value="dogandcat">Dog & Cat</md-radio-button>
                                <md-radio-button value="others">Others</md-radio-button>
                              </md-radio-group>

                        </div>








                                <div class="row regnsml">
                                    <div class="col-12">
                                            <button  class="btn login" type="submit" [disabled]="!registrationform.valid">Notify Me</button>
                                    </div>


                                      </div>
        </form>
                </div>

  </div>
</div>
</div>
-->


<div style="margin:10px">
  <h2 style="margin-top: 55px; color: #9b7544">TARIFF CARD: </h2>
    <table class="table table-bordered text-center" >
      <tr style="font-size:18px">
        <td style="color: #9b7544"><b> Item</b></td>
        <td style="color: #9b7544"><b> Duration</b></td>
        <td style="color: #9b7544"><b> Price</b></td>
        <td style="color: #9b7544"><b> Introductory Offer</b></td>
      </tr>
      <tr style="font-size:18px">
          <td style="color: #9b7544"> Dog Park</td>
          <td style="color: #9b7544"> 2 Hrs</td>
          <td style="color: #9b7544"> 300/-</td>
          <td style="color: #9b7544"> 200/-</td>
        </tr>
        <tr style="font-size:18px">
            <td style="color: #9b7544">Swimming Pool</td>
            <td style="color: #9b7544">1 Hrs</td>
            <td style="color: #9b7544">350/-</td>
            <td style="color: #9b7544">250/-</td>
          </tr>
          <tr style="font-size:18px">
              <td style="color: #9b7544">Day Package <br> <a style="font-size: 14px" >(Unlimited access to swimming pool & play areas)</a></td>
              <td style="color: #9b7544">10 am to 6 pm</td>
              <td style="color: #9b7544">699/-</td>
              <td style="color: #9b7544">499/-</td>
            </tr>
            <tr style="font-size:18px">
                <td style="color: #9b7544"> Day Boarding</td>
                <td style="color: #9b7544">9 am to 6 pm</td>
                <td style="color: #9b7544">500/-</td>
                <td style="color: #9b7544">400/-</td>
              </tr>
              <tr style="font-size:18px">
                  <td style="color: #9b7544"> Boarding</td>
                  <td style="color: #9b7544"> Day 1 <br> Day 2 <br> Day 3</td>
                  <td style="color: #9b7544">999/- <br> 999/- <br> 999/-</td>
                  <td style="color: #9b7544"> Pay for 2 Days and avail the 3rd Day Free</td>
                </tr>

    </table>

    <a style="font-size: 14px; color: #9b7544"> Conditions apply. GST @ 18% will be applicable on all charges. Right of admission reserved. </a>

  </div>